<template>
  <search-provider
    :placename="placename"
    :selected-category-ids="categoryIds"
    :data-lang="lang"
  />
</template>

<script setup lang="ts">
import { useNuxtApp, useRoute, createError } from 'nuxt/app'
import { computed, onMounted } from 'vue'
import { httpHeadersCache } from '~/apps/search/helpers'
import { isSearchUrlRoute } from '~/apps/search/isSearchUrlComponent'
import { ensureArray } from '~/utility/array'
import { GLAMPING_CATEGORIES } from '~/utility/glamping'

// Page metadata
definePageMeta({
  key: 'GlampingCategorySearchPage',
  // Removed layout: false to use default layout at build time instead of runtime
  validate: (route) => isSearchUrlRoute(route),
  httpHeaders: (to) => httpHeadersCache(to),
  meta: {
    type: 'glamping',
    category: 'glamping',
    app: 'search',
  },
})

const route = useRoute()
const { $gtm } = useNuxtApp()

if (!isSearchUrlRoute(route)) {
  throw createError({
    statusCode: 404,
    statusMessage: `Page Not Found: ${route.path}`,
    fatal: process.client,
  })
}

// Constants
const categoryIds = GLAMPING_CATEGORIES
const slug = 'glamping'

// Computed properties
const lang = computed(() => route.params.lang || 'en-gb')

const placename = computed(
  () => ensureArray(route.query.placename)[0] || undefined,
)

const category = computed(() => ({
  categoryId: categoryIds.join(','),
  rootSlug: slug,
}))

// Lifecycle
onMounted(() => {
  $gtm?.push({
    pageCategories: ['glamping'].join(','),
  })
})

// Watchers
watch(
  () => category.value,
  () => {
    void nextTick(() => {
      $gtm?.push({
        pageCategories: category.value.rootSlug,
      })
    })
  },
  { immediate: true },
)
</script>
